<template>
  <div class="page boss-page supervisor-home-page">
    <van-nav-bar title="主管工作台" left-arrow @click-left="$router.back()"/>
    <section class="summary">
      <div class="clickable" @click="go('SupervisorMonitor')"><span>团队人数</span><b>{{ data.teamSize || 0 }}</b></div>
      <div class="clickable" @click="go('SupervisorReviews')"><span>待核验</span><b>{{ data.pendingReview || 0 }}</b></div>
      <div><span>提交率</span><b>{{ num(data.submissionRate) }}%</b></div>
      <div><span>平均分</span><b>{{ num(data.averageScore) }}</b></div>
    </section>
    <main>
      <button @click="go('SupervisorReviews')">
        <van-icon name="todo-list-o"/>
        <span><b>待核验列表</b><small>复核下属日志与评分</small></span><em>{{ data.pendingReview || 0 }}</em></button>
      <button @click="go('SupervisorStrategyWorkbench')">
        <van-icon name="cluster-o"/>
        <span><b>战略执行工作台</b><small>复审任务、分配人员并查看团队执行</small></span>
        <van-icon name="arrow"/>
      </button>
      <button @click="go('SupervisorCorrections')">
        <van-icon name="guide-o"/>
        <span><b>纠偏验收</b><small>处理员工反馈、执行证据与验收结果</small></span>
        <van-icon name="arrow"/>
      </button>
      <button @click="go('EfficiencyLeaderboard')">
        <van-icon name="bar-chart-o"/>
        <span><b>团队排行榜</b><small>查看团队绩效排名</small></span>
        <van-icon name="arrow"/>
      </button>
      <button @click="go('SupervisorMonitor')">
        <van-icon name="completed"/>
        <span><b>团队提交监控</b><small>提交率、缺交人员与催办依据</small></span>
        <van-icon name="arrow"/>
      </button>
      <button @click="go('SupervisorDiagnosis')">
        <van-icon name="chart-trending-o"/>
        <span><b>月度汇总分析</b><small>本月下属工作与绩效综合情况</small></span>
        <van-icon name="arrow"/>
      </button>
      <button @click="go('SupervisorWeeklyBrief')">
        <van-icon name="newspaper-o"/>
        <span><b>纠偏周报</b><small>行业情报 + 团队弱项形成下周动作</small></span>
        <van-icon name="arrow"/>
      </button>
    </main>
  </div>
</template>
<script>
/**
 * 主管工作台首页：团队概览 KPI + 核验/排行榜/监控/诊断入口。
 */
import coreapi from '@/utils/coreapi';

export default {
  data() {
    const d = new Date();
    return {month: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`, data: {}}
  },
  mounted() {
    this.load()
  },
  activated() {
    this.load()
  },
  methods: {
    load() {
      return coreapi.supervisorDashboard(this.month).then(v => this.data = v).catch(e => {
        this.$toast.fail(e.message);
        this.$router.back()
      })
    },
    go(n) {
      this.$router.push({name: n, query: {supervisor: n === 'EfficiencyLeaderboard' ? '1' : undefined}})
    },
    num(v) {
      return Number(v || 0).toFixed(1)
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../boss/boss.less';
@import "~@/assets/base.less";
@import "./supervisor.less";

.page {
  min-height: 100vh;
  padding-bottom: .45rem;
  background: #f6f7fb;
  color: #333;
  letter-spacing: 0
}

.summary {
  padding: .3rem .28rem;
  display: grid;
  grid-template-columns:repeat(2, minmax(0, 1fr));
  gap: .16rem
}

.summary div {
  position: relative;
  min-height: 1.35rem;
  padding: .24rem .26rem;
  overflow: hidden;
  background: #fff;
  border-radius: .2rem;
  box-shadow: 0 .06rem .24rem rgba(211, 47, 47, .09);
  box-sizing: border-box
}

.summary div:before {
  content: "";
  position: absolute;
  left: 0;
  top: .24rem;
  width: .06rem;
  height: .46rem;
  border-radius: 0 .05rem .05rem 0;
  background: @color
}

.summary div:nth-child(2):before {
  background: #D32F2F
}

.summary div:nth-child(3):before {
  background: #35a56f
}

.summary div:nth-child(4):before {
  background: #D32F2F
}

.summary span, .summary b {
  display: block
}

.summary span {
  color: #8a8da3;
  font-size: .24rem
}

.summary b {
  margin-top: .09rem;
  color: #34364a;
  font-size: .43rem;
  line-height: 1.05
}

.summary .clickable {
  cursor: pointer;
  transition: transform .12s ease;
  background: #fff
}

:active {
  transform: scale(.97)
}

main {
  margin: 0 .28rem .3rem;
  overflow: hidden;
  background: #fff;
  border-radius: .24rem;
  box-shadow: 0 .08rem .3rem rgba(211, 47, 47, .1)
}

main button {
  width: 100%;
  min-height: 1.35rem;
  padding: .23rem .28rem;
  display: flex;
  align-items: center;
  border-bottom: 1PX solid #eee;
  text-align: left;
  background: #fff
}

main button:last-child {
  border-bottom: 0
}

main button > .van-icon:first-child {
  width: .72rem;
  height: .72rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 .72rem;
  color: @color;
  font-size: .4rem;
  border-radius: .16rem;
  background: #fff5f5
}

main button:nth-child(3) > .van-icon:first-child {
  color: #2d9561;
  background: #eaf7f0
}

main button:nth-child(4) > .van-icon:first-child {
  color: #d9891b;
  background: #fff4e5
}

main button:nth-child(5) > .van-icon:first-child {
  color: #3c6fbf;
  background: #eef3ff
}

main span {
  min-width: 0;
  margin-left: .22rem;
  flex: 1
}

main b, main small {
  display: block
}

main b {
  color: #34364a;
  font-size: .32rem
}

main small {
  margin-top: .06rem;
  color: #9295a7;
  font-size: .24rem;
  line-height: 1.35
}

main button > .van-icon:last-child {
  color: #b0b2c0;
  font-size: .28rem
}

main em {
  min-width: .48rem;
  padding: .06rem .12rem;
  color: #fff;
  text-align: center;
  border-radius: .3rem;
  background: #D32F2F;
  font-size: .23rem;
  font-style: normal;
  box-sizing: border-box
}
.supervisor-home-page { margin: 0; min-height: 100vh; background: #f6f7fb; padding-bottom: 1.7rem; }
.supervisor-home-page /deep/ .van-nav-bar { margin: 0; width: 100%; height: 1.22667rem; border-radius: 0; background: linear-gradient(135deg,#351b1d,#c6282d); }
.supervisor-home-page .summary, .supervisor-home-page main { box-shadow: 0 .06rem .24rem rgba(30,35,60,.06); }
</style>



// WEBPACK FOOTER //
// src/views/efficiency/supervisor/Home.vue